import parse from 'html-react-parser';


export const parseHMTLData=(data)=> parse(`${data}`)